import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormCodeEditor from 'components/forms/FormCodeEditor';

class DocTemplateContent extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={8}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div class="form-group-attached">
                    <FormCodeEditor
                      name="body"
                      label={messages.content}
                      value={entity.getBody()}
                      meta={entity.getBodyMetaInformation()}
                      validation={entity.getBodyValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      language="html"
                    />
                    <FormCodeEditor
                      name="footer"
                      label={messages.footer}
                      value={entity.getFooter()}
                      meta={entity.getFooterMetaInformation()}
                      validation={entity.getFooterValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      language="html"
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
DocTemplateContent.defaultProps = {
  inModal: false,
};

export default injectIntl(DocTemplateContent);
